import {IHttpService} from "angular";
import {TradingLevelRequest} from "./models/TradingLevelRequest";

export class TradingLevelService {

    public static id = "tradingLevelService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async post(request: TradingLevelRequest): Promise<TradingLevelRequest> {
        const url = `/tradefloor/api/trading-level/validate`;
        try {
            const response = await this.$http.post<TradingLevelRequest>(url, request);
            return response.data!;
        } catch (e) {
            const message = e.data.error;
            return Promise.reject(message);
        }
    }
}
